import { useEffect, useState } from "react";
// import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { getLocale } from "react-i18nify";

import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import Button from "src/components/core/Button";

import EditComponent from "./Edit";
import AddComponent from "./Add";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    paddingBottom: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
}));

const Modal = ({
  type = "desc",
  descData = "",
  docType,
  dataSearch,
  setDataSearch,
  suggestDescList,
  setSuggestDescList,
  isOpen = false,
  isEdit,
  onClose,
  onSubmit,
}) => {
  const [editTextDesc, setEditTextDesc] = useState("");
  
  useEffect(() => {
    if (isOpen) {
      setEditTextDesc(descData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // const getDescText = async () => {
  //   let text = ""
  //   suggestDescList
  //     .filter((item) => item.isSelect === true)
  //     // eslint-disable-next-line array-callback-return
  //     .map((selected, i) => {
  //       if (text === "")
  //         text = `${selected?.description_text}`
  //       else 
  //         text = `${text}\n${selected?.description_text}`
  //     });
    
  //   await onSubmit(text);
  // };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 740,
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center", }}>
        {type === "remark"
          ? `เพิ่มหมายเหตุสินค้า`
          : docType === "service"
            ? `แนะนำรายละเอียดการบริการ`
            : docType === "product"
              ? `แนะนำรายละเอียดสินค้า`
              : `แนะนำรายละเอียด`}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            borderRadius: "50%",
            border: "1px solid var(--lightgrey-color)",
            position: "absolute",
            right: 16,
            top: 16,
            color: "var(--primary-color)",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      {isEdit
        ? (
          <>
            <DialogContent
              sx={{
                px: 3,
                width: "100%",
                "& .MuiBox-root": {
                  maxWidth: "530px",
                  mx: "auto",
                },
              }}
            >
              <EditComponent
                type={type}
                docType={docType}
                textDesc={editTextDesc}
                setTextDesc={setEditTextDesc}
                suggestDescList={suggestDescList}
                setSuggestDescList={setSuggestDescList}
              />
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 4 }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => onSubmit(editTextDesc)}
                sx={{ minWidth: 350, borderRadius: 4, py: 1.5 }}
                disabled={
                  type === "remark" && editTextDesc?.length > 400
                }
              >
                {getLocale() === "th" ? "ยืนยัน" : "Confirm"}
              </Button>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogContent
              sx={{
                px: 3,
                width: "100%",
                position: "relative",
                "& .MuiBox-root": {
                  maxWidth: "530px",
                  mx: "auto",
                },
              }}
            >
              <AddComponent
                type={type}
                docType={docType}
                dataSearch={dataSearch}
                setDataSearch={setDataSearch}
                suggestDescList={suggestDescList}
                setSuggestDescList={setSuggestDescList}
                textDesc={editTextDesc}
                setTextDesc={setEditTextDesc}
              />
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 4 }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => onSubmit(editTextDesc)}
                disabled={
                  // suggestDescList.filter((val) => val.isSelect === true).length < 1
                  editTextDesc === "" || ( type === "remark" && editTextDesc?.length > 400)
                }
                sx={{ minWidth: 350, borderRadius: 4, py: 1.5 }}
              >
                {getLocale() === "th" ? "ยืนยัน" : "Confirm"}
              </Button>
            </DialogActions>
          </>
        )
      }
    </Dialog>
  );
};

export default Modal;
